"use strict";
exports.REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-metadata/src/core/directives/controller/constants.js
// module id = 431
// module chunks = 0